import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Participation } from '@app/api';
import { ApplyToStudies } from '../../Home/components/ApplyToStudies';
import { EmptyState } from './EmptyState';
import InboxBlue from '@app/illu/Small/InboxBlue.svg';
import { StudiesCardContainer } from './StudiesCardContainer';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  cardContainer: {
    width: '100%',
    maxWidth: theme.maxContentWidth.reduced,
    minWidth: 'auto',
    overflow: 'hidden',
    borderRadius: theme.borderRadius.large,
    marginBottom: theme.marginBase,
    [theme.media.homeScreen]: {
      width: '100%',
      minWidth: 'auto',
    },
  },
}));

interface Props {
  participations: Participation[];
}

export const StudiesMatched = ({ participations }: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const noParticipation = !participations || participations.length === 0;

  return (
    <StudiesCardContainer noParticipation={noParticipation}>
      {noParticipation ? (
        <EmptyState
          illustration={InboxBlue}
          alt="Inbox"
          title={t('studies.empty.matched.title')}
          description={t('studies.empty.matched.description')}
        />
      ) : (
        participations.map((participation) => {
          return participation.session ? (
            <ApplyToStudies
              key={participation.id}
              participation={participation}
              session={participation.session}
              className={classes.cardContainer}
            />
          ) : null;
        })
      )}
    </StudiesCardContainer>
  );
};
